var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDoubleArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21.44,
  height: 16.73
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9 1v14.7a1 1 0 0 0 1 1 1 1 0 0 0 .63-.2L21 9.19a1 1 0 0 0 .27-1.39.87.87 0 0 0-.27-.27L10.6.2a1 1 0 0 0-1.4.2A1 1 0 0 0 9 1",
  fill: "currentColor",
  "data-name": "Layer 1-2"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 1v14.7a1 1 0 0 0 1 1 1 1 0 0 0 .63-.2L12 9.19a1 1 0 0 0 .27-1.39.87.87 0 0 0-.27-.27L1.6.2A1 1 0 0 0 .2.4 1 1 0 0 0 0 1",
  fill: "currentColor",
  "data-name": "Layer 1-2"
}))))));
export default SvgDoubleArrowRight;